export default __webpack_public_path__ + "static/media/shopping-cart-light.c0026793.svg";